import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';

import InputMask from '../../../legacyCore/MaskedInput';
import { coalesceFieldErrors } from './utils';

type Props = FieldRenderProps & {
  mask: any;
};

export default class InputMaskAdapter extends React.Component<Props> {
  render() {
    const { input, meta, mask, ...props } = this.props;
    let valid;
    if (meta.touched) {
      valid = coalesceFieldErrors(meta).length === 0;
    }
    return <InputMask {...input} {...props} valid={valid} mask={mask} />;
  }
}
